import { render, staticRenderFns } from "./Thing.vue?vue&type=template&id=08801a6d&scoped=true&"
import script from "./Thing.vue?vue&type=script&lang=ts&"
export * from "./Thing.vue?vue&type=script&lang=ts&"
import style0 from "./Thing.vue?vue&type=style&index=0&id=08801a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08801a6d",
  null
  
)

export default component.exports